import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, getTranslatedValue, toasterrormsg} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import Fancybox from '../Fancybox'
import {SpaceRentalDetailsHeader} from './SpaceRentalDetailsHeader'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const SpaceRentalOverview: FC = () => {
  let  t = Tr()
  const lang = useLang()
  const location = useLocation()
  const spacerentalId = (location.state as any)?.spacerentalId || ''
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([])
    const [qqsList, setQqsList] = useState([])

  const spaceDetailsApiCall = async () => {
    var param: any = {
      spacerentalId: String(spacerentalId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      setSpacerentalDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  }
  useEffect(() => {
    spaceDetailsApiCall()
  }, [])

  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number)
    const period = hours >= 12 ? 'PM' : 'AM'
    const adjustedHours = hours % 12 || 12
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes // Ensure minutes are two digits
    return `${adjustedHours}:${formattedMinutes} ${period}`
  }
  const qqsListApiCall = async () => {
    var response: any = await fetchData('vendor/public/qqsList', {})
    if (response.status == '200') {
      const filterData = response.data.map((item: any) => ({label: item.name, value: item.qqsId}))
      setQqsList(filterData)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    qqsListApiCall()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Space Rental Overview")}</PageTitle>
      <ToastContainer />
      <SpaceRentalDetailsHeader />
      {spaceRenatalDetails.map((spaceRenatal: any, index: any) => {
                    var selectedQqs :any = qqsList.find((option: any) => option.value === spaceRenatal["qqs"]) || null

        return (
          <div className='form' key={index}>
            {/* <!--begin::Card--> */}
            <div className='card'>
              {/* <!--begin::Card header--> */}
              <div className='card-header'>
                {/* <!--begin::Card header--> */}
                <div className='card-title fs-3 fw-bold'>{t("Basic Info")}</div>
                {/* <!--end::Card header--> */}
              </div>
              {/* <!--end::Card header--> */}
              {/* <!--begin::Card body--> */}
              <div className='card-body'>
                {spaceRenatal['en_name'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Property Name (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['en_name']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {spaceRenatal['ru_name'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Property Name (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['ru_name']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {spaceRenatal['uz_name'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Property Name (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['uz_name']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                { spaceRenatal['subcategory'] && spaceRenatal['subcategory'].map((spacerentalcategory: any) => {
                  return (
                    <>
                      {spacerentalcategory['en_name'] ? (
                        <>
                          {/* <!--begin::Row--> */}
                          <div className='row mb-8'>
                            {/* <!--begin::Col--> */}
                            <div className='col-xl-3'>
                              <div className='fs-6 fw-bold mt-2 mb-3'>{t("Space Type")}</div>
                            </div>
                            {/* <!--end::Col--> */}

                            {/* <!--begin::Col--> */}
                            <div className='col-xl-9'>
                              {/* <!--begin::Progress--> */}
                              <div className='d-flex flex-column'>
                                <div className=' fw-semibold text-gray-600 mt-3'>
                                  <div>{spacerentalcategory['en_name']}</div>
                                </div>
                              </div>
                              {/* <!--end::Progress--> */}
                            </div>
                            {/* <!--end::Col--> */}
                          </div>
                          {/* <!--end::Row--> */}
                        </>
                      ) : (
                        ''
                      )}
                    </>
                  )
                })}
                {spaceRenatal['accountName'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Host Name")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['accountName']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {spaceRenatal['contact_person_name'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Contact Person Name")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['contact_person_name']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {spaceRenatal['email'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Email")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['email']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {spaceRenatal['phoneNo'] && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Mobile Number")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            {spaceRenatal['phoneNo']}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                {spaceRenatal['socialMediaChannels'] &&
                  spaceRenatal['socialMediaChannels'].length > 0 && (
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Social Media Links")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className='fw-semibold text-gray-600 mt-3'>
                            {/* Render each social media type and link on a new line */}
                            {spaceRenatal['socialMediaChannels']
                              .filter(
                                (channel: any) =>
                                  channel['socialMediaType'] && channel['socialMediaLink']
                              ) // Filter out channels without type or link
                              .map((channel: any, index: number) => (
                                <p key={index}>
                                  <strong>{channel['socialMediaType']}:</strong>
                                  {'  '}
                                  <a
                                    href={channel['socialMediaLink']}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                    {channel['socialMediaLink']}
                                  </a>
                                </p>
                              ))}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                  )}
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Property Location")}</div>
                </div>
                {spaceRenatal['location'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Location")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div>{spaceRenatal['location']} </div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                { spaceRenatal['vendorDetails'] && spaceRenatal['vendorDetails'].map((vendordetail: any) => {
                  return (
                    <>
                      { vendordetail['country'] && vendordetail['country'].map((country: any) => {
                        return (
                          <>
                            {country['name'] ? (
                              <>
                                {/* <!--begin::Row--> */}
                                <div className='row mb-8'>
                                  {/* <!--begin::Col--> */}
                                  <div className='col-xl-3'>
                                    <div className='fs-6 fw-bold mt-2 mb-3'>{t("Country")}</div>
                                  </div>
                                  {/* <!--end::Col--> */}

                                  {/* <!--begin::Col--> */}
                                  <div className='col-xl-9'>
                                    {/* <!--begin::Progress--> */}
                                    <div className='d-flex flex-column'>
                                      <div className=' fw-semibold text-gray-600 mt-3'>
                                        <div>{country['name']}</div>
                                      </div>
                                    </div>
                                    {/* <!--end::Progress--> */}
                                  </div>
                                  {/* <!--end::Col--> */}
                                </div>
                                {/* <!--end::Row--> */}
                              </>
                            ) : (
                              ''
                            )}
                          </>
                        )
                      })}

                      {vendordetail['addressline1'] ? (
                        <>
                          {/* <!--begin::Row--> */}
                          <div className='row mb-8'>
                            {/* <!--begin::Col--> */}
                            <div className='col-xl-3'>
                              <div className='fs-6 fw-bold mt-2 mb-3'>{t("Address Line 1")}</div>
                            </div>
                            {/* <!--end::Col--> */}

                            {/* <!--begin::Col--> */}
                            <div className='col-xl-9'>
                              {/* <!--begin::Progress--> */}
                              <div className='d-flex flex-column'>
                                <div className=' fw-semibold text-gray-600 mt-3'>
                                  <div>{vendordetail['addressline1']}</div>
                                </div>
                              </div>
                              {/* <!--end::Progress--> */}
                            </div>
                            {/* <!--end::Col--> */}
                          </div>
                          {/* <!--end::Row--> */}
                        </>
                      ) : (
                        ''
                      )}

                      {vendordetail['addressline2'] ? (
                        <>
                          {/* <!--begin::Row--> */}
                          <div className='row mb-8'>
                            {/* <!--begin::Col--> */}
                            <div className='col-xl-3'>
                              <div className='fs-6 fw-bold mt-2 mb-3'>{t("Address Line 2")}</div>
                            </div>
                            {/* <!--end::Col--> */}

                            {/* <!--begin::Col--> */}
                            <div className='col-xl-9'>
                              {/* <!--begin::Progress--> */}
                              <div className='d-flex flex-column'>
                                <div className=' fw-semibold text-gray-600 mt-3'>
                                  <div>{vendordetail['addressline2']}</div>
                                </div>
                              </div>
                              {/* <!--end::Progress--> */}
                            </div>
                            {/* <!--end::Col--> */}
                          </div>
                          {/* <!--end::Row--> */}
                        </>
                      ) : (
                        ''
                      )}
                      {vendordetail['region'] ? (
                        <>
                          {/* <!--begin::Row--> */}
                          <div className='row mb-8'>
                            {/* <!--begin::Col--> */}
                            <div className='col-xl-3'>
                              <div className='fs-6 fw-bold mt-2 mb-3'>{t("Region")}</div>
                            </div>
                            {/* <!--end::Col--> */}

                            {/* <!--begin::Col--> */}
                            <div className='col-xl-9'>
                              {/* <!--begin::Progress--> */}
                              <div className='d-flex flex-column'>
                                <div className=' fw-semibold text-gray-600 mt-3'>
                                  <div>{getTranslatedValue( lang ,vendordetail['regionDetail'][0] , "_name")}</div>
                                </div>
                              </div>
                              {/* <!--end::Progress--> */}
                            </div>
                            {/* <!--end::Col--> */}
                          </div>
                          {/* <!--end::Row--> */}
                        </>
                      ) : (
                        ''
                      )}
                      {vendordetail['zipcode'] ? (
                        <>
                          {/* <!--begin::Row--> */}
                          <div className='row mb-8'>
                            {/* <!--begin::Col--> */}
                            <div className='col-xl-3'>
                              <div className='fs-6 fw-bold mt-2 mb-3'>{t("Zip Code")}</div>
                            </div>
                            {/* <!--end::Col--> */}

                            {/* <!--begin::Col--> */}
                            <div className='col-xl-9'>
                              {/* <!--begin::Progress--> */}
                              <div className='d-flex flex-column'>
                                <div className=' fw-semibold text-gray-600 mt-3'>
                                  <div>{vendordetail['zipcode']}</div>
                                </div>
                              </div>
                              {/* <!--end::Progress--> */}
                            </div>
                            {/* <!--end::Col--> */}
                          </div>
                          {/* <!--end::Row--> */}
                        </>
                      ) : (
                        ''
                      )}
                    </>
                  )
                })}

                {spaceRenatal['en_generalInformation'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t("Property Details")}</div>
                  </div>
                ) : (
                  ''
                )}
                {spaceRenatal['en_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("General Information (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['en_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['ru_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("General Information (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['ru_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['uz_generalInformation'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("General Information (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['uz_generalInformation'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {spaceRenatal['amenity'].length > 0 ||
                spaceRenatal['serviceLanguageDetail'].length > 0 ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t("Facilities & Services")}</div>
                  </div>
                ) : (
                  ''
                )}
                { spaceRenatal['amenity'] && spaceRenatal['amenity'].length > 0 ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Space Amenities")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {spaceRenatal['amenity'].map((amenity: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                {getTranslatedValue(lang  , amenity , "_name")}
                                {index !== spaceRenatal['amenity'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {  spaceRenatal['serviceLanguageDetail'] &&  spaceRenatal['serviceLanguageDetail'].length > 0 ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Service Languages")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {spaceRenatal['serviceLanguageDetail'].map(
                            (serviceLanguages: any, index: any) => {
                              return (
                                <div key={index} className='fw-semibold text-gray-600 mt-0'>
                                  {getTranslatedValue(lang  , serviceLanguages , "_name")}
                                  {index !== spaceRenatal['serviceLanguageDetail'].length - 1
                                    ? ', '
                                    : ''}
                                </div>
                              )
                            }
                          )}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Space Availability")}</div>
                </div>
                {/* <!--begin::Row--> */}
                <div className='row mb-8'>
                  {/* <!--begin::Col--> */}
                  <div className='col-xl-3'>
                    <div className='fs-6 fw-bold mt-2 mb-3'>{t("Allow In Day")}</div>
                  </div>
                  {/* <!--end::Col--> */}

                  {/* <!--begin::Col--> */}
                  <div className='col-xl-9'>
                    {/* <!--begin::Progress--> */}
                    <div className='d-flex flex-column'>
                      <div className=' fw-semibold text-gray-600 mt-3'>
                        {spaceRenatal['isAllowDay'] != 0 ? 'Yes' : 'No'}
                      </div>
                    </div>
                    {/* <!--end::Progress--> */}
                  </div>
                  {/* <!--end::Col--> */}
                </div>
                {/* <!--end::Row--> */}
                {/* <!--begin::Row--> */}
                <div className='row mb-8'>
                  {/* <!--begin::Col--> */}
                  <div className='col-xl-3'>
                    <div className='fs-6 fw-bold mt-2 mb-3'>{t("Allow In Night")}</div>
                  </div>
                  {/* <!--end::Col--> */}

                  {/* <!--begin::Col--> */}
                  <div className='col-xl-9'>
                    {/* <!--begin::Progress--> */}
                    <div className='d-flex flex-column'>
                      <div className=' fw-semibold text-gray-600 mt-3'>
                        {spaceRenatal['isAllowNight'] != 0 ? 'Yes' : 'No'}
                      </div>
                    </div>
                    {/* <!--end::Progress--> */}
                  </div>
                  {/* <!--end::Col--> */}
                </div>

                {spaceRenatal['en_userGuide'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t("Policies")}</div>
                  </div>
                ) : (
                  ''
                )}
                {spaceRenatal['en_userGuide'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("User Guide (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['en_userGuide'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['ru_userGuide'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("User Guide (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['ru_userGuide'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['uz_userGuide'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("User Guide (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['uz_userGuide'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['en_cancellationPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Cancellation Policy (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['en_cancellationPolicy'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['ru_cancellationPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Cancellation Policy (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['ru_cancellationPolicy'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['uz_cancellationPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Cancellation Policy (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: spaceRenatal['uz_cancellationPolicy'],
                              }}
                            ></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                { spaceRenatal['openingHours'] &&  spaceRenatal['openingHours'].length > 0 && (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Opening Hours")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          {spaceRenatal['openingHours'].map((dayInfo: any, index: any) => (
                            <div className='fw-semibold text-gray-600 mt-3' key={index}>
                              <div>
                                <strong>{t("Day")}:</strong> {dayInfo.day}
                              </div>
                              {dayInfo.timeSlot.map((slot: any, slotIndex: any) => (
                                <div key={slotIndex}>
                                  <strong>{t("Time Slot")} {slotIndex + 1}:</strong>{' '}
                                  {formatTime(slot.startTime)} - {formatTime(slot.endTime)}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                )}
                 { spaceRenatal['customPolicy'] && spaceRenatal['customPolicy'].length > 0 ? (
                  <div className='col-xl-3 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t("Custom Policy")}</div>
                  </div>
                ) : (
                  ''
                )}
                <div className='custom-docs-container'>
                  {spaceRenatal['customPolicy'] &&
                    spaceRenatal['customPolicy'].length > 0 &&
                    spaceRenatal['customPolicy'].map((item: any, index: any) => {
                      return (
                        <div key={index} className='custom-docs-item'>
                          {item.en_title && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t("Custom Policy English Title")}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['en_title'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.en_description && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t("Custom Policy English Description")}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['en_description'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.ru_title && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t("Custom Policy Russian Title")}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['ru_title'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.ru_description && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t("Custom Policy Russian Description")}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['ru_description'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.uz_title && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t("Custom Policy Uzbek Title")}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['uz_title'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {item.uz_description && (
                            <div className='custom-docs-block'>
                              <div className='col-xl-3'>
                                <div className='fs-6 fw-bold mt-2 mb-3'>
                                  {t("Custom Policy Uzbek Description")}
                                </div>
                              </div>
                              <div className='col-xl-9'>
                                <div className='d-flex flex-column'>
                                  <div className='fw-semibold text-gray-600 mt-3'>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item['uz_description'],
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    })}
                </div>

                {spaceRenatal['ownerName'] != '' ? (
                  <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                    <div className='fs-3 fw-bold mb-5 '>{t("Finance and Legal Info")}</div>
                  </div>
                ) : (
                  ''
                )}
                {spaceRenatal['ownerName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Owner Name")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['ownerName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['passportNumber'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Passport Number")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['passportNumber'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['jShShIR'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("jShShIR")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['jShShIR'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['businessName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Business Name")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['businessName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['businessSTIR'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Business STIR")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['businessSTIR'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                  {spaceRenatal['qqs'] && selectedQqs ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("QQS")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                          <div dangerouslySetInnerHTML={{__html: selectedQqs.label}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {spaceRenatal['mxikkodi']  ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("MXIK kodi")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                          <div dangerouslySetInnerHTML={{__html: spaceRenatal['mxikkodi']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['oIchovBirligi']  ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("O'Ichov Birligi")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                          <div dangerouslySetInnerHTML={{__html: spaceRenatal['oIchovBirligi']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {spaceRenatal['bankName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Bank Name")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['bankName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['branchName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Branch Name")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['branchName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['accountName'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Account Name")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['accountName'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['accountNumber'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("Account Number")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['accountNumber'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['mfo'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("MFO")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['mfo'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                {spaceRenatal['stir'] && (
                  <div className='row mb-8'>
                    {/* <!--begin::Col--> */}
                    <div className='col-xl-3'>
                      <div className='fs-6 fw-bold mt-2 mb-3'>{t("STIR")}</div>
                    </div>
                    {/* <!--end::Col--> */}

                    {/* <!--begin::Col--> */}
                    <div className='col-xl-9'>
                      {/* <!--begin::Progress--> */}
                      <div className='d-flex flex-column'>
                        <div className=' fw-semibold text-gray-600 mt-3'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: spaceRenatal['stir'],
                            }}
                          ></div>
                        </div>
                      </div>
                      {/* <!--end::Progress--> */}
                    </div>
                    {/* <!--end::Col--> */}
                  </div>
                )}
                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                  {spaceRenatal['businessDocument'] != '' ? (
                    <Fancybox options={opts}>
                      {/* <!--begin::Col--> */}
                      <div className='col-md-4 mb-11 mb-md-0' key={index}>
                        {/* <!--begin::Overlay--> */}
                        <a
                          data-fancybox='gallery'
                          className='d-block overlay'
                          data-fslightbox='lightbox-hot-sales'
                          href={spaceRenatal['businessDocument']}
                        >
                        
                          <div
                            className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                            style={{
                              height: '266px',
                              backgroundImage: `url('${spaceRenatal['businessDocument']}')`,
                            }}
                          ></div>
                          {/* <!--end::Image--> */}

                          {/* <!--begin::Action--> */}
                          <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                            <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                          </div>
                          {/* <!--end::Action-->       */}
                        </a>
                        {/* <!--end::Overlay-->          */}
                      </div>
                      {/* <!--end::Col-->      */}
                    </Fancybox>
                  ) : (
                    ''
                  )}

                  {spaceRenatal['idProofDocument'] != '' ? (
                    <Fancybox options={opts}>
                      {/* <!--begin::Col--> */}
                      <div className='col-md-4 mb-11 mb-md-0' key={index}>
                        {/* <!--begin::Overlay--> */}
                        <a
                          data-fancybox='gallery'
                          className='d-block overlay'
                          data-fslightbox='lightbox-hot-sales'
                          href={spaceRenatal['idProofDocument']}
                        >
                       
                          <div
                            className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                            style={{
                              height: '266px',
                              backgroundImage: `url('${spaceRenatal['idProofDocument']}')`,
                            }}
                          ></div>
                          {/* <!--end::Image--> */}
                          {/* <!--begin::Action--> */}
                          <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                            <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                          </div>
                          {/* <!--end::Action-->       */}
                        </a>
                        {/* <!--end::Overlay-->          */}
                      </div>
                      {/* <!--end::Col-->      */}
                    </Fancybox>
                  ) : (
                    ''
                  )}
                </div>
                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Space Rental Photos")}</div>
                </div>
                { spaceRenatal['images'] &&  spaceRenatal['images'].length != 0 ? (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 7--> */}
                    <div className='card card-flush h-xl-100'>
                      <div className='pt-7'>
                        <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                          {spaceRenatal['images'].map((images: any, index: any) => {
                            return (
                              <>
                                <Fancybox options={opts}>
                                  {/* <!--begin::Col--> */}
                                  <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                    {/* <!--begin::Overlay--> */}
                                    <a
                                      data-fancybox='gallery'
                                      className='d-block overlay'
                                      data-fslightbox='lightbox-hot-sales'
                                      href={images['mediaPath']}
                                    >
                                      <div
                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                        style={{
                                          height: '266px',
                                          backgroundImage: `url('${images['mediaPath']}')`,
                                        }}
                                      ></div>
                                      {/* <!--end::Image--> */}

                                      {/* <!--begin::Action--> */}
                                      <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                      </div>
                                      {/* <!--end::Action-->       */}
                                    </a>
                                    {/* <!--end::Overlay-->          */}
                                  </div>
                                  {/* <!--end::Col-->      */}
                                </Fancybox>
                              </>
                            )
                          })}
                        </div>
                        {/* <!--end::Row--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Engage widget 7--> */}
                  </div>
                ) : (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 1--> */}
                    <div className='card h-md-100' dir='ltr'>
                      {/* <!--begin::Body--> */}
                      <div className='card-body d-flex flex-column flex-center'>
                        {/* <!--begin::Heading--> */}
                        <div className='mb-2'>
                          {/* <!--begin::Illustration--> */}
                          <div className='py-10 text-center'>
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                              className='theme-light-show h-125px'
                              alt=''
                            />
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                              className='theme-dark-show h-125px'
                              alt=''
                            />
                          </div>
                          {/* <!--end::Illustration--> */}
                        </div>
                        {/* <!--end::Heading--> */}
                      </div>
                      {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::Engage widget 1--> */}
                  </div>
                )}
              </div>

            </div>
            {/* <!--end::Card--> */}
          </div>
        )
      })}
    </>
  )
}

export {SpaceRentalOverview}
